import $ from 'jquery';
import 'bootstrap-datepicker';
import moment from 'moment';

// SUI calendar doesn't do a proper module export, so we need to shim it
import 'semantic-ui-calendar/dist/calendar.js';

const DEFAULT_ORIENTATION = 'bottom';

function range() {
  const $range = $('.ui.cal.range');
  const $form = $range.closest('form');

  $range.each((index, element) => {
    const $element = $(element);

    const orientation =
      $element.attr('data-orientation') || DEFAULT_ORIENTATION;

    $element.attr('autocomplete', 'off');

    $element
      .datepicker({
        language: 'fr',
        autoclose: true,
        orientation,
        clearBtn: true,
      })
      .on('changeDate', evt => {
        $form.submit();
      });

    // const fromDate = $from.datepicker('getDate');
    // if (fromDate) {
    //   $to.datepicker('setStartDate', fromDate);
    // }
  });
}

// Enabling SUI calendar
const calendarOptions = {
  firstDayOfWeek: 1,
  ampm: false,
  text: {
    days: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    months: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Decembre',
    ],
    monthsShort: [
      'Jan',
      'Fev',
      'Mar',
      'Avr',
      'Mai',
      'Jun',
      'Jul',
      'Aou',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    today: "Aujourd'hui",
    now: 'Maintenant',
    am: 'AM',
    pm: 'PM',
  },
};

export default function bind() {
  // Options du datepicker
  $.fn.datepicker.dates['fr'] = {
    days: [
      'Dimanche',
      'Lundi',
      'Mardi',
      'Mercredi',
      'Jeudi',
      'Vendredi',
      'Samedi',
    ],
    daysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    daysMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    months: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ],
    monthsShort: [
      'Jan',
      'Fev',
      'Mar',
      'Avr',
      'Mai',
      'Jui',
      'Juil',
      'Aou',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    today: "Aujourd'hui",
    clear: 'Effacer',
    format: 'dd/mm/yyyy',
    titleFormat: 'MM yyyy',
    weekStart: 1,
  };

  $.fn.calendarFr = function(params) {
    const format = params.format || 'DD/MM/YYYY';

    return $.fn.calendar.call(this, {
      ...calendarOptions,
      parser: {
        date: (text, settings) => {
          if (text) {
            return moment(text, format).toDate();
          } else {
            return undefined;
          }
        },
      },
      formatter: {
        date: (date, settings) => {
          return moment(date).format(format);
        },
        hourHeader: date => moment(date).format('dddd DD'),
        datetime: date => {
          if (!date) {
            return undefined;
          }

          return moment(date).format(format);
        },
        time: date => moment(date).format('HH:mm'),
      },
      ...params,
    });
  };

  $('input.datepicker').each((index, element) => {
    const $element = $(element);

    const orientation =
      $element.attr('data-orientation') || DEFAULT_ORIENTATION;

    $element.attr('autocomplete', 'off');

    $element
      .datepicker({
        language: 'fr',
        autoclose: true,
        orientation,
        disableTouchKeyboard: true,
      })
      .on('focusout', function() {
        var d = $element.val();
        var last3 = d.substr(-3);
        // determine if the last 3 characters contain the character: /
        if (d.length > 6 && d.length < 10 && last3.indexOf('/') > -1) {
          var currentYearStr = moment()
            .year()
            .toString();
          var currentCentury = currentYearStr.substring(0, 2) * 1;
          var last2 = d.substr(-2);
          // determine if the last 2 characters contain the character: /
          if (last2.indexOf('/') > -1) {
            // determine which century, within 50 years of the current year, to prepend and prepend that and decade 0 to the 1 digit year:
            var last = d.substr(-1) * 1;
            var yeardiff = currentYearStr.substring(0, 2) * 1 - last;
            if (yeardiff > 50) currentCentury++;
            d = d.slice(0, d.length - 1);
            d = d + currentCentury.toString() + '0' + last;
          } else {
            // determine which century, within 50 years of the current year, to prepend and prepend that to the 2-digit year:
            last2 = last2 * 1;
            var yeardiff = currentYearStr.substring(0, 2) * 1 - last2;
            if (yeardiff > 50) currentCentury++;
            else if (yeardiff < -50) currentCentury--;
            d = d.slice(0, d.length - 2);
            d = d + currentCentury.toString() + last2;
          }
          // store/display the properly formated date
          $element.datepicker('setDate', d);
        }
      });
  });

  $('.timepicker').each((index, element) => {
    const $element = $(element);

    const orientation =
      $element.attr('data-orientation') || DEFAULT_ORIENTATION;

    $element.attr('autocomplete', 'off');

    $element.calendarFr({
      type: 'time',
      format: 'HH:mm',
      language: 'fr',
      autoclose: true,
      orientation,
      disableTouchKeyboard: true,
    });
  });

  range();
}



// WEBPACK FOOTER //
// ./src/plugins/datepicker.js